import * as React from 'react'
import {
  Button,
  CardActions,
  CircularProgress,
  TextField,
} from '@material-ui/core'
import { makeStyles } from '@material-ui/core/styles'
import { Field, Form } from 'react-final-form'
import { useNotify, useSafeSetState, useTranslate, useRedirect } from 'ra-core'
import Typography from '@material-ui/core/Typography'
import AuthPageLayout from '../../components/AuthPageLayout'
import httpClient from '../../providers/httpClient'
import envConfig from '../../environments'

const useStyles = makeStyles(theme => ({
  form: {
    padding: '8px 0 0',
  },
  input: {
    marginTop: '1em',
  },
  button: {
    width: '100%',
    padding: '12px 0',
    borderRadius: 10,
    fontWeight: 600,
  },
  formIcon: {
    marginRight: theme.spacing(1),
  },
  backLink: {
    marginTop: 16,
    textAlign: 'center',
  },
}))

const Input = ({
  meta: { touched, error }, // eslint-disable-line react/prop-types
  input: inputProps, // eslint-disable-line react/prop-types
  ...props
}) => (
  <TextField
    error={!!(touched && error)}
    helperText={touched && error}
    variant="outlined"
    {...inputProps}
    {...props}
    fullWidth
  />
)

const ForgotPassword = () => {
  const classes = useStyles()
  const translate = useTranslate()
  const [loading, setLoading] = useSafeSetState(false)
  const redirect = useRedirect()
  const notify = useNotify()

  const validate = values => {
    const errors = { email: undefined }
    if (!values.email) {
      errors.email = translate('ra.validation.required')
    }
    return errors
  }

  const submit = values => {
    setLoading(true)
    httpClient(`${envConfig.backendUrl}/forgot-password`, {
      method: 'POST',
      body: JSON.stringify(values),
    })
      .then(() => {
        notify('surveys.messages.forgot_password_success', { type: 'success' })
        redirect('/login')
      })
      .catch(() => {
        notify('surveys.messages.forgot_password_error', { type: 'warning' })
      })
      .finally(() => {
        setLoading(false)
      })
  }

  return (
    <AuthPageLayout
      title={translate('surveys.messages.reset_password')}
      subtitle={translate('surveys.messages.reset_password_text')}
    >
      <Form
        onSubmit={submit}
        validate={validate}
        render={({ handleSubmit }) => (
          <form onSubmit={handleSubmit} noValidate>
            <div className={classes.form}>
              <div className={classes.input}>
                <Field
                  autoFocus
                  id="email"
                  name="email"
                  component={Input}
                  label="Email"
                  disabled={loading}
                />
              </div>
            </div>
            <CardActions style={{ padding: '16px 0 0' }}>
              <Button
                variant="contained"
                type="submit"
                color="primary"
                disabled={loading}
                className={classes.button}
              >
                {loading && (
                  <CircularProgress
                    className={classes.formIcon}
                    size={18}
                    thickness={2}
                  />
                )}
                {translate('surveys.messages.send_instructions')}
              </Button>
            </CardActions>
            <Typography
              variant="body2"
              color="primary"
              className={classes.backLink}
              style={{ cursor: 'pointer' }}
              onClick={() => redirect('/login')}
            >
              {translate('ra.action.back')}
            </Typography>
          </form>
        )}
      />
    </AuthPageLayout>
  )
}

export default ForgotPassword
